import type { ListBuilderList } from '../../../types';

/**
 * No Active License (PD-16226) — the list behind the Compliance dashboard's
 * "No Active License" card, so Review lands on exactly the accounts the card
 * counted.
 *
 * Before this the card linked to `/licenses/matching?tab=manual`, the whole
 * Pending Manual Match queue: republic's card read 82 while that tab held
 * 4,730 rows, sorted by expiration ascending, so it opened on 1899/2000 dates
 * and on accounts the card excludes (test customers, ACCOUNT CLOSED, BAD DEBT,
 * DENIED). No combination of the tab's filters could reproduce the 82, because
 * neither the population nor the coverage bucket existed as a filter.
 *
 * The population is the dashboard's own: a Customer with a sale in the last 90
 * days whose lifecycle is not Closed / Dormant / Not Interested
 * (`licenseActiveBuyer: yes`), holding licences but with none verified and no
 * suggestion at 90%+ (`licenseClientCoverage: no_active_license`). Both filters
 * are shared with the dashboard's SQL, so the count matches the card.
 *
 * Default sort is `recent-sale-desc`: the client who bought most recently and
 * still has no usable licence is the first call to make.
 */
export const noActiveLicenseList: ListBuilderList = {
	id: 'default-licenses-no-active-license',
	cacheTTL: 300000,
	name: 'No Active License',
	type: 'default',
	// PD-16252: superseded by Needs Attention → No Verified License, which has its own
	// columns and actions. Inactive (no tab) but still openable by URL so saved
	// links keep working.
	active: false,
	// Ahead of the other risk tabs — it is the dashboard's loudest card.
	sortOrder: 4,
	filterRules: {
		// Visible (Chris 2026-09-18): the tab name says the coverage bucket,
		// but not that the list is limited to active buyers — without the
		// chip the page looks unfiltered while showing 189 of thousands.
		licenseActiveBuyer: {
			defaultValue: [{ id: 'yes', label: 'Buying (sale in 90 days)' }],
			locked: true,
		},
		licenseClientCoverage: {
			defaultValue: [{ id: 'no_active_license', label: 'No Active License' }],
			locked: true,
			hidden: true,
		},
	},
	defaultSortId: 'recent-sale-desc',
	inheritsFrom: 'default-licenses-all',
};
